var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: `tooltip-${_vm.unique}` } },
    [
      _c("c-button", {
        staticClass: "toggle-button",
        attrs: {
          id: "tooltip-" + _vm.unique,
          disabled: _vm.disabled,
          icon: {
            icon: "chevron",
            color: "blue",
          },
          active: _vm.value,
        },
        on: { click: _vm.toggle },
      }),
      _vm.disabled
        ? _c(
            "b-popover",
            {
              attrs: {
                triggers: "hover blur",
                target: `tooltip-${_vm.unique}`,
              },
            },
            [_vm._v(" " + _vm._s(_vm.disabledPopover) + " ")]
          )
        : _c(
            "b-popover",
            {
              attrs: {
                target: "tooltip-" + _vm.unique,
                triggers: "hover",
                placeholder: "top",
              },
            },
            [_vm._v(" " + _vm._s(_vm.value ? "Свернуть" : "Развернуть") + " ")]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }